// UAT Morocco environment
export const environment = {
  production: false,

  API_URL: 'https://uatapi.pay10.ma',
  API_URLBLAZE: 'https://uatapi.pay10.ma',
  API_URLPG: 'https://globalapipg.pay10.com/crmws/shield-api/',
  API_URLBLAZEOLD: 'https://uatapi.pay10.ma',
  API_URL1: 'https://uatapi.pay10.ma/api/v1',

  USER_KEY: 'logged-user',
  appSystem: '',
  adminUser: 'admin@pay10.ma',
  expiryTokenTime: 30 * 60 * 1000,
  level3_exclude: ['Reseller List', 'Merchant/Agent Master', 'Customer Master'],
  defaultPageSize: 10,
  defaultPageSizeArr: [10, 20, 30, 40, 50],
  defaultCurrency: 'MAD',
  defaultCountry: 'MA',
  defaultCountryCode: 'MA',
  defaultCountryName: 'Morocco',
  defaultPhoneCode: '212',

  piiSecretKey: 'adsfeh2o32o98932jfoi32u9032r98uegf2i3o487'
};
